"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var Link_1 = __importDefault(require("../Link"));
var Image_1 = __importDefault(require("../Image"));
var LinkContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return (__assign({ minWidth: '80px', height: '26px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: theme.space[3], marginRight: theme.space[3], cursor: 'pointer' }, (selected && {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.colors.primary,
    })));
});
var RegionSelector = function (props) {
    var regions = props.regions, footerRegion = props.footerRegion, availableRegions = props.availableRegions;
    var regionProps = regions;
    if (regions && availableRegions && availableRegions.length > 0) {
        regionProps = regions.filter(function (item) { return availableRegions.includes(item.value); });
    }
    var handleRegionChange = function (domain) {
        if (typeof window !== 'undefined') {
            // https://www.ff.com/us/ff-91 -> ff-91
            var slug = window.location.href.split('/').slice(4).join('/');
            window.location.href = "" + domain + slug;
        }
    };
    return (react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "center" }, regionProps === null || regionProps === void 0 ? void 0 : regionProps.map(function (region) {
        return react_1.default.createElement(LinkContainer, { key: region.domain, selected: region.value === footerRegion },
            react_1.default.createElement(Link_1.default, { onClick: function () { return handleRegionChange(region.domain); } },
                react_1.default.createElement(Image_1.default, { src: region.imgUrl, alt: region.value, px: "27px" })));
    })));
};
exports.default = RegionSelector;
